import axiosClient from "./axios-clients-handlers";
import {
  ProdutionBase
} from "../utils/constants";

const localHostURL = "http://localhost/myhealthcarelife/wp-json";
const nodeBaseURL = "http://localhost:5510";
const prodBaseURL = "https://www.isanjaykumar.com/wp-json";

let baseURL = '';
if (ProdutionBase === true) {
  baseURL = prodBaseURL;
} else {
  baseURL = localHostURL;
}

//For Login Token
export async function getUserToken($payload) {
  let axiosApiURL = `${baseURL}/userauth/v1/token`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    }
  );
  return response;
}

//For Date Activity
export async function getPastDate(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/date`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  return response;
}


//For Pre Market Data
export async function getPreMarketData(token) {
  // let axiosApiURL = `https://www.isanjaykumar.com/wp-content/plugins/nseindia/json/market-data-pre-open.json`;
  // let axiosApiURL = `https://www.nseindia.com/api/market-data-pre-open?key=ALL`;
  let axiosApiURL = `/json/market-data-pre-open.json`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}

//For Open Market Data
export async function getOpenMarketData($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/today-open`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


//For Total Market Data
export async function getTotalMarketData(token) {
  let axiosApiURL = `${nodeBaseURL}/totalmarket`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  return response;
}


//For Increase Open Intrest
export async function getIncreaseOIList(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/oilist`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}

//For Sector Performance
export async function getSectorHeatmapPerformance($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/heatmap-sector`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }
  );
  return response;
}


//For Delivery Percent List by date
export async function getDeliveryPercentListByDate($param, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/delivery_date?d=${$param}`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}


//For Delivery Percent List
export async function getDeliveryPercentList($date, $template, $sector, $symbol, $series, $days, token) {
  let query = [
    $date ? `d=${encodeURIComponent($date)}` : null,
    $template ? `t=${encodeURIComponent($template)}` : null,
    $sector ? `sector=${encodeURIComponent($sector)}` : null, 
    $symbol ? `s=${encodeURIComponent($symbol)}` : null,
    $series ? `series=${encodeURIComponent($series)}` : null,
    $days ? `days=${encodeURIComponent($days)}` : null
  ].filter(Boolean).join('&');

  let axiosApiURL = `${baseURL}/endpoints/v1/delivery${query ? `?${query}` : ''}`;
  // let axiosApiURL = `http://localhost/myhealthcarelife/wp-json/endpoints/v1/delivery${query ? `?${query}` : ''}`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }

  );
  return response;
}


//For Chartink List
export async function getChartinkList(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/chartink-alert`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}



//For BulkDeals List
export async function getBulkList($param, token) {
  let axiosApiURL = $param ? `${baseURL}/endpoints/v1/bulk?d=${$param}` : `${baseURL}/endpoints/v1/bulk`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}

//For Symbol List
export async function getSymbolList($series, $type, token) {
let query = [
    $type ? `type=${encodeURIComponent($type)}` : null,
    $series ? `series=${encodeURIComponent($series)}` : null
  ].filter(Boolean).join('&');

  let axiosApiURL = `${baseURL}/endpoints/v1/symbol${query ? `?${query}` : ''}`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}


//For Planet Transit List
export async function getPlanetTransit(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/transit`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}


//For Add to WatchList
export async function postWatchList($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/watchlist`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


//For Show WatchList
export async function myWatchList(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/mywatchlist`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}


//For Show holdinglist
export async function holdinglistList(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/holdinglist`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}

//For Delete item from WatchList
export async function watchlistItemDelete($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/watchlistItemDelete`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

// For add item to setupList

export async function addtosetupStock($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/addtosetuplist`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

//For Add item in Portfolio List
export async function addPortfolioList($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/addportfolio`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


//For Show PortfolioList
export async function myPortfolioList(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/myportfolio`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}


//For Get My Prediction
export async function getMyPrediction($param, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/prediction?d=${$param}`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}



//For Get Spike Stocks
export async function getSpikes($param, token) {
  let axiosApiURL = $param ? `${baseURL}/endpoints/v1/spike?d=${$param}` : `${baseURL}/endpoints/v1/spike`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}

// For Momentum Stocks
export async function getMomentumListByDate($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/today-momentum`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

//For All Symbol from Google Sheet
export async function getGoogleSheet($date, token) {
  // let axiosApiURL = `https://script.google.com/macros/s/AKfycbx02oVijB1Zs9E7mbqyfVLthS0D0a7CKp_bLYR1lRp2-TJ3F6mPT5V_QHSaGJGxh2_l/exec`;
  let axiosApiURL = $date ? `${baseURL}/endpoints/v1/todayUpdate?d=${$date}` : `${baseURL}/endpoints/v1/todayUpdate`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}

// For Momentum Stocks
export async function getHotStarFevUpdate($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/hotstar-fev-update`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


// For Momentum Stocks
export async function getNR7BreakoutStokcs($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/nr7breakout`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


// For Today's Market
export async function getTodayMarketPL($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/today-market`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

// For Indices Activity Date
export async function getIndicesData(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/indices?d=231025`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}

// For Golden CrossOver
export async function getGoldenCrossOver(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/crossover`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}

// For Method types Stocks
export async function getMethodTypeStocks($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/method-type`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

//For Get Trend Setup
export async function getMyTrendSetup(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/setups`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}

//For Delete item from Setup List
export async function setuplistItemDelete($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/setup-item-remove`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


//For Update item in Setup List
export async function setuplistItemUpdate($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/setup-item-update`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

//For Get intradaysetup
export async function getIntrdaySetup($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/intradaysetup`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


//For Get intradaysetup
export async function getIndicesActivity($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/indicesActivity`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

export async function getSectorRotationByRanked($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/sector-rotation`;
  // let axiosApiURL = `http://localhost/myhealthcarelife/wp-json/endpoints/v1/sector-rotation`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

export async function getSectorRotation($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/sector-performance`;
  // let axiosApiURL = `http://localhost/myhealthcarelife/wp-json/endpoints/v1/sector-performance`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

export async function getComboRotation($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/combo-performance`;
  // let axiosApiURL = `http://localhost/myhealthcarelife/wp-json/endpoints/v1/combo-performance`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

export async function getStockDetails($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/stock-details`;
  // let axiosApiURL = `http://localhost/myhealthcarelife/wp-json/endpoints/v1/stock-details`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


export async function addNewOrderUpdate($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/addneworderUpdate`;
  // let axiosApiURL = `http://localhost/myhealthcarelife/wp-json/endpoints/v1/addneworderUpdate`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

// For OrderList
export async function getOrdersList(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/orderslist`;
  // let axiosApiURL = `http://localhost/myhealthcarelife/wp-json/endpoints/v1/orderslist`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}

// For Orders Update
export async function getOrdersUpdate($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/orders-update`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


export async function getOrderRemove($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/orderRemove`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


export async function saveLeadingSectors($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/save-leading-sectors`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}

export async function getDurationDaysPrice($payload, token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/get-duration-price`;
  const response = await axiosClient.post(`${axiosApiURL}`,
    $payload, {
      headers: {
        Authorization: `Bearer ${token}`, // send token
      },
    }
  );
  return response;
}


export async function getLeadingSectors(token) {
  let axiosApiURL = `${baseURL}/endpoints/v1/get-leading-sectors`;
  const response = await axiosClient.get(`${axiosApiURL}`, {
    headers: {
      Authorization: `Bearer ${token}`, // send token
    },
  });
  return response;
}
